import React, { useState, useEffect } from 'react'
import css from '../css/gamehis.module.css'
import ReactPaginate from 'react-paginate'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { BsChatDots } from 'react-icons/bs'
// import Header from "../Components/Header";
import Rightcontainer from '../Components/Rightcontainer'
import axios from 'axios'
import socket from '../Components/socket'
import { useHistory  } from 'react-router-dom'
import { toast } from 'react-toastify'
import { apiRequest } from '../../apiService/allApi'
import { Margin } from '@mui/icons-material'

const Gamehistory = () => {

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 
  const [user, setUser] = useState()
  let limit = 50
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory ()

  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    // await axios
    //   .get(baseUrl+`me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers)
    // .then(res => {
    setUser(res.data)

    //Allgames(res.data._id)
    Allgames(res.data._id, pageNumber, limit)
    // window.location.reload()
    // })
  }

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)

  }
  const [game, setGame] = useState([])
  // console.log(game)

  const Allgames = async id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    setIsLoading(true)

    try {
      const res = await apiRequest(`game/history/user/${id}?page=${pageNumber}&_limit=${limit}`, "GET", null, headers)
      let gameHis = []
      res.data.data.forEach(ele => {
        if (
          ele.Status == 'completed' ||
          ele.Status == 'cancelled' ||
          ele.Status == 'conflict'
        ) {
          gameHis.push(ele)
        }
      })
      setGame(gameHis)
      setNumberOfPages(res.data.totalPages)
      setIsLoading(false)
    } catch (e) {
    }
  }

  const dateFormat = e => {
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }

  useEffect(() => {
    role()
    //eslint-disable-next-line
  }, [pageNumber, limit])





  // change theme 
  const theme = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
    color: theme === 'light' ? 'black' : '#fff',

  };

  return (
    <div>
      <div className='leftContainer bgbox' style={{ ...styles, paddingTop: "0px", }}>
        <div className='  Orher_page_main_section bgbox ' style={{ ...styles, paddingBottom: "10vh !important" }}>

          {/* game card   */}
          {isLoading ? (
            <div className='text-center'>
              <div className='loaderReturn' style={{ zIndex: '99' }}>
                <img
                  src={'/images/LandingPage_img/loader1.gif'}
                  style={{ width: '100%' }}
                />
              </div>
              {/* Add any loading spinner or animation here */}
            </div>
          ) : game && game.length == 0 ? (
            <div className='text-center not_found_box_main'>
              <img
                src='./images/not-found.gif'
                alt='no data'
              />
              <div className='mt-2'>
                <h3 className='font-weight-bold'>No Game History</h3>
                <p>You have no game history yet.</p>
              </div>
            </div>
          ) : (
            game &&
            game.map(card => (
              <>
                <div className='other_pages_card_main justify-contemt-start'>
                  <div className='card_date default-date d-block gaming_chat_icon_main  pr-3'>

                    <div class="backside border-right">
                      
                  <div className="card_date default-date d-block gaming_chat_icon_main  pr-3">
                        <p>{dateFormat(card.createdAt).split(",")[0]}</p>
                        <p>{dateFormat(card.createdAt).split(",")[1]}</p>
                      </div>
                      </div>
                    
                    {/* <p className=''>
                      {dateFormat(card.createdAt).split(',')[0]}
                    </p>
                    <p className='ml-2'>{dateFormat(card.createdAt).split(',')[1]}</p> */}
                  </div>

                  <div className='side-class'>

                    <p className=' transaction_msg '>
                      Game is  {card.Status === "completed"
                        ? card.Winner && card.Winner._id === user._id
                          ? "Win"
                          : "Loss"
                        : card.Status} 
                    </p>
                   
                   

                    <p className="">
                      <span
                        className={`  btn-bg text-white ${card.Status === "completed"
                          ? card.Winner && card.Winner._id === user._id
                            ? "btn-success" // Green for Win
                            : "btn-danger" // Red for Loss
                          : "btn-warning " // Default for other statuses
                          }`}
                      >
                        <b>
                          {card.Status === "completed"
                            ? card.Winner && card.Winner._id === user._id
                              ? "Win"
                              : "Loss"
                            : card.Status}
                        </b>
                      </span>
                    </p>
                             <p className=' transaction_msg '>Room Code {card.Room_code}</p>
                  </div>
                  <div className='transaction_right_side_main'>

                    <p className="transaction_msg closingbl">
                      Cl Bal : ₹ {' '}
                      {(card.Acceptor_status == "cancelled" && card.Accepetd_By.id === user.id) ? (
                        card.Winner_closingbalance
                      ) : card.Creator_Status == "cancelled" ? (
                        card.Loser_closingbalance
                      ) : card.Winner?.id === user._id ? (
                        card.Winner_closingbalance
                      ) : (
                        
                        card.Loser_closingbalance
                      )}
                    </p>

                    <p className=' transaction_msg mt-2'>
                      Win Amount :<span>{card.winnAmount}</span>
                    </p>
                  </div>
                </div>

              </>
            ))
          )}
        </div>
      </div>

      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </div>
  )
}

export default Gamehistory
